import {getRequest, postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
// 玩家属性域：基础信息（fantasyUserBO）/详情（fantasyUserDetail）/属性点（fantasyUserProperty）/头像（userHeader）
// 全局收拢：所有组件 mapState 订阅，写路径统一走 mutations/actions，替代 eventHub 广播刷新
let detailPromise = null
let headerPromise = null

export default {
  namespaced: true,
  state: {
    fantasyUserBO: {},
    fantasyUserDetail: {},
    fantasyUserProperty: {},
    userHeader: {}
  },
  mutations: {
    SET_FANTASY_USER(state, user) {
      state.fantasyUserBO = user || {};
    },
    SET_USER_DETAIL(state, payload) {
      payload = payload || {};
      state.fantasyUserDetail = payload.fantasyUserDetail || {};
      state.fantasyUserProperty = payload.fantasyUserProperty || {};
    },
    SET_USER_HEADER(state, header) {
      state.userHeader = header || {};
    }
  },
  actions: {
    // 拉取玩家详情+属性点（showCurUserDetail），模块级共享 Promise 去重（多组件同时触发只发一次请求）
    fetchUserDetail({commit}) {
      if (!detailPromise) {
        detailPromise = getRequest('/user/user/showCurUserDetail', {}).then(resp => {
          if (resp.status == 200) {
            const respData = resp.data;
            if (200 == respData.status) {
              commit('SET_USER_DETAIL', respData.data || {});
            } else {
              Message.error(respData.message);
            }
          } else {
            Message.error('用户非法⊙﹏⊙∥!');
          }
        }, () => {
          Message.error('用户非法⊙﹏⊙∥!');
        }).then(() => {
          detailPromise = null;
        }).catch(() => {
          detailPromise = null;
        });
      }
      return detailPromise;
    },
    // 拉取玩家头像部件（getUserHeaderInfo）
    fetchUserHeader({commit}, userId) {
      if (!userId) return Promise.resolve();
      if (!headerPromise) {
        headerPromise = getRequest('/user/userHeader/getUserHeaderInfo', {userId: userId}).then(resp => {
          if (resp.status == 200 && resp.data && resp.data.status == 200 && resp.data.data) {
            commit('SET_USER_HEADER', resp.data.data);
          }
        }, () => {}).then(() => {
          headerPromise = null;
        }).catch(() => {
          headerPromise = null;
        });
      }
      return headerPromise;
    }
  }
}
